import { useCallback } from 'react';
import { useNavigate } from 'react-router';

const useGoToPromos = () => {
  const navigate = useNavigate();

  const goToPromos = useCallback(() => {
    navigate('/promos', { replace: true });
  }, [navigate]);

  return goToPromos;
};

export default useGoToPromos;
